module.exports = __webpack_public_path__ + "img/am_inactive.837bf0ac.svg";